import { appendLocaleSources } from '../../hooks/useTranslate'
import ResponsibilitiesPresenter from '../../api/responsibilitiesPresenter'

appendLocaleSources({
  [ResponsibilitiesPresenter.urn]: {
    page: {
      title: 'Ответсвенные лица',
    },
    modal: {
      title: {
        create: 'Создать отвественное лицо',
        update: 'Обновить отвественное лицо',
      },
    },
    action: {
      create: 'Добавить отвественное лицо',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить это отвественное лицо?`,
    },
  },
}, 'ru')

appendLocaleSources({
  [ResponsibilitiesPresenter.urn]: {
    page: {
      title: 'Responsible Persons',
    },
    modal: {
      title: {
        create: 'Create Responsible Person',
        update: 'Update Responsible Person',
      },
    },
    action: {
      create: 'Add Responsible Person',
    },
    message: {
      confirmDelete: `Are you sure you want to delete this responsible person?`,
    },
  },
}, 'en')

appendLocaleSources({
  [ResponsibilitiesPresenter.urn]: {
    page: {
      title: 'Masul shaxslar',
    },
    modal: {
      title: {
        create: 'Masul shaxs yaratish',
        update: 'Masul shaxsni yangilash',
      },
    },
    action: {
      create: 'Masul shaxs qoshish',
    },
    message: {
      confirmDelete: `Ushbu mas'ul shaxsni o'chirishni xohlaysizmi?`,
    },
  },
}, 'uz')

